const serviceData = [
    {
        title: "تبلیغات روی خودروها",
        subtitle: "Advertising on Vehicles",
        description: "تبلیغ برندها و محصولات شما با استفاده از خودروهای شخصی و عمومی در سطح شهر.",
        icon: (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M15.51 2.82996H8.49C6 2.82996 5.45 4.06996 5.13 5.58996L4 11H20L18.87 5.58996C18.55 4.06996 18 2.82996 15.51 2.82996Z"
                    stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path
                    d="M21.99 19.82C22.1 20.99 21.16 22 19.96 22H18.08C17 22 16.85 21.54 16.66 20.97L16.46 20.37C16.18 19.55 16 19 14.56 19H9.43998C7.99998 19 7.78998 19.62 7.53998 20.37L7.33998 20.97C7.14998 21.54 6.99998 22 5.91998 22H4.03998C2.83998 22 1.89998 20.99 2.00998 19.82L2.56998 13.73C2.70998 12.23 2.99998 11 5.61998 11H18.38C21 11 21.29 12.23 21.43 13.73L21.99 19.82Z"
                    stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M4 8H3" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M21 8H20" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12 3V5" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M10.5 5H13.5" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path d="M6 15H9" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M15 15H18" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>

        ),
    },
    {
        title: "کمپین‌های هدفمند",
        subtitle: "Targeted Campaigns",
        description: "برنامه‌ریزی و اجرای کمپین‌های تبلیغاتی دقیق با تمرکز بر جلب توجه مخاطبین خاص.",
        icon: (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.15002 2V22" stroke="#fffff" stroke-width="1.5" stroke-miterlimit="10"
                      stroke-linecap="round" stroke-linejoin="round"/>
                <path
                    d="M5.15002 4H16.35C19.05 4 19.65 5.5 17.75 7.4L16.55 8.6C15.75 9.4 15.75 10.7 16.55 11.4L17.75 12.6C19.65 14.5 18.95 16 16.35 16H5.15002"
                    stroke="#fffff" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                    stroke-linejoin="round"/>
            </svg>

        ),
    },
    {
        title: "تحلیل و اندازه‌گیری عملکرد",
        subtitle: "Performance Analytics",
        description: "دریافت گزارش‌های دقیق از میزان تأثیرگذاری تبلیغات و بهینه‌سازی کمپین‌ها بر اساس داده‌های واقعی.",
        icon: (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 22H22" stroke="#ffffff" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path d="M9.75 4V22H14.25V4C14.25 2.9 13.8 2 12.45 2H11.55C10.2 2 9.75 2.9 9.75 4Z" stroke="#ffffff"
                      stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M3 10V22H7V10C7 8.9 6.6 8 5.4 8H4.6C3.4 8 3 8.9 3 10Z" stroke="#ffffff" stroke-width="1.5"
                      stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M17 15V22H21V15C21 13.9 20.6 13 19.4 13H18.6C17.4 13 17 13.9 17 15Z" stroke="#ffffff"
                      stroke-width="1.5"
                      stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        ),
    },
    {
        title: "تبلیغات در مکان‌های پر تردد",
        subtitle: "Advertising in High Traffic Areas",
        description: "قرار دادن تبلیغات در مکان‌هایی با بیشترین تردد افراد مانند ایستگاه‌های مترو، پارک‌ها، و مراکز خرید.",
        icon: (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2Z"
                    stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path
                    d="M12 6V18"
                    stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path
                    d="M10 9L12 12L14 9"
                    stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        ),
    },
];

const ServiceItem = ({title, subtitle, description, icon}) => (
    <article
        className="flex flex-col justify-center items-start p-7 bg-[#F9F9FB] border border-white rounded-3xl shadow-2xl">
        <div className="flex md:flex-row flex-col items-center justify-start gap-4">
            <div className="p-3 bg-primary text-white rounded-2xl">
                <svg width="50px" height="100%" viewBox="0 0 24 24" fill="none" stroke="#ffffff"
                     xmlns="http://www.w3.org/2000/svg">
                    {icon}
                </svg>
            </div>
            <h3 className="font-bold text-primary text-lg text-start">{title}</h3>
        </div>
        <p className="text-gray-500 text-right pt-8 leading-loose max-md:hidden">
            {description}
        </p>
    </article>
);

const Service = () => (
    <section>
        <div className="flex flex-col items-center pt-36 container">
            <h2 className="font-bold text-4xl mb-3 max-w-[750px] leading-normal text-gray-800">
                خدماتی که ما را <span className="text-primary">متمایز</span> می‌کند
            </h2>
            <p className="text-xl font-medium text-gray-500">
                تبلیغات نوآورانه و هدفمند با استفاده از ابزارهای متنوع برای برندهای مختلف.
            </p>
            <div className="grid md:grid-cols-4 grid-cols-2 mt-14 md:gap-10 gap-5">
                {serviceData.map((item, index) => (
                    <ServiceItem key={index} {...item} />
                ))}
            </div>
        </div>
    </section>
);

export default Service;
